import './PropertyFeatures.css';

interface AddressFeatures {
    bd?: number;
    bt?: number;
    fa?: { v: number; u: string };
}

interface PropertyFeaturesProps {
    features: AddressFeatures;
}

const AREA_UNIT_LABELS: Record<string, string> = {
    'sqm': 'm\u00B2',
    'sqft': 'ft\u00B2',
};

const BedIcon = () => (
    <svg className="property-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21V14h18v7" />
        <path d="M3 14V10a1 1 0 011-1h16a1 1 0 011 1v4" />
        <path d="M5 9V7a1 1 0 011-1h4a1 1 0 011 1v2" />
        <path d="M13 9V7a1 1 0 011-1h4a1 1 0 011 1v2" />
        <path d="M3 17h18" />
    </svg>
);

const BathIcon = () => (
    <svg className="property-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 12h16a1 1 0 011 1v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3a1 1 0 011-1z" />
        <path d="M6 12V5a2 2 0 012-2h0a2 2 0 012 2v1" />
        <path d="M7 20v2" />
        <path d="M17 20v2" />
    </svg>
);

const FloorAreaIcon = () => (
    <svg className="property-feature-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h6v6H3" />
        <path d="M9 3v6" />
        <path d="M3 9h6" />
    </svg>
);

const PropertyFeatures = ({ features }: PropertyFeaturesProps) => {
    if (!features || (features.bd == null && features.bt == null && features.fa == null)) {
        return null;
    }

    return (
        <div className="property-features">
            {features.bd != null && (
                <div className="property-feature-item">
                    <BedIcon />
                    <span className="property-feature-value">{features.bd}</span>
                    <span className="property-feature-label">{features.bd === 1 ? 'Bed' : 'Beds'}</span>
                </div>
            )}
            {features.bt != null && (
                <div className="property-feature-item">
                    <BathIcon />
                    <span className="property-feature-value">{features.bt}</span>
                    <span className="property-feature-label">{features.bt === 1 ? 'Bath' : 'Baths'}</span>
                </div>
            )}
            {features.fa != null && (
                <div className="property-feature-item">
                    <FloorAreaIcon />
                    <span className="property-feature-value">{features.fa.v}</span>
                    <span className="property-feature-label">{AREA_UNIT_LABELS[features.fa.u] || features.fa.u}</span>
                </div>
            )}
        </div>
    );
};

export default PropertyFeatures;
